module.exports = __webpack_public_path__ + "img/ff-insta-1-3.c6684b61.jpg";